import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getStoredPreferences } from '@/hooks/useCookieConsent';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Check if user has consented to analytics cookies
    const preferences = getStoredPreferences();
    if (!preferences || !preferences.analytics) {
      // User hasn't consented to analytics - don't track
      return;
    }

    // Send page view to GA
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-1W6QQX52TJ', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
};
